const idWrapper = document.querySelector(".tax__personal-id");

if (idWrapper) {
  const supportContainer = document.querySelector(
    ".support-form__animation-box"
  );

  const taxCheckBox = document.getElementById("tax");
  taxCheckBox.addEventListener("change", () => {
    supportContainer.classList.toggle("support-form__animation-box--open-max");
    idWrapper.parentElement.classList.toggle(
      "tax__personal-id-animation-box--open"
    );
    idWrapper.classList.toggle("hidden");
  });
}
